export default "__VITE_ASSET__CKB539ZV__"